import { getAccessToken } from "@/authSession"

export const getToken = async () => {
  return await getAccessToken()
}
